import { render, staticRenderFns } from "./RiskCheckAllSafetyLog.vue?vue&type=template&id=2f0f69fa&scoped=true&"
import script from "./RiskCheckAllSafetyLog.vue?vue&type=script&lang=js&"
export * from "./RiskCheckAllSafetyLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0f69fa",
  null
  
)

export default component.exports